import { ImpressionWindowEntityType } from '@kinopoisk-int/evgen-web-events/web/named_enums';

export enum ShowcaseId {
    KP_BASIC = 'kp_basic',
    YA_PREMIUM = 'ya_premium',
    TVOD_EST = 'tvod_est',
    HOME = 'home',
    ONBOARDING = 'onboarding',
    CRUNCHYROLL = 'crunchyroll',
    CRUNCHYROLL_ONBOARDING = 'crunchyroll_onboarding',
    LOGINWALL = 'loginwall_showcase_web_touch',
    AMEDIATEKA = 'amediateka_allplay',
    AMEDIATEKA_ONBOARDING = 'onboarding_amediateka',
}

const selectionTypenameMap: Record<string, ImpressionWindowEntityType> = {
    AnnounceSelection: ImpressionWindowEntityType.ANNOUNCE,
    ChannelProgramsSelection: ImpressionWindowEntityType.CHANNELPROGRAMS,
    ChannelsSelection: ImpressionWindowEntityType.CHANNEL,
    EditorialFeatureSelection: ImpressionWindowEntityType.EDITORIALFEATURE,
    MultiSelection: ImpressionWindowEntityType.MULTISELECTION,
    OriginalsSelection: ImpressionWindowEntityType.ORIGINALS,
    OttTopSelection: ImpressionWindowEntityType.OTTTOP,
    PromoSelection: ImpressionWindowEntityType.PROMO,
    Selection: ImpressionWindowEntityType.SELECTION,
    SnippetSelection: ImpressionWindowEntityType.SNIPPET,
    ContinueWatchingEmbeddedSelection: ImpressionWindowEntityType.CONTINUEWATCHING,
    WatchLaterSelection: ImpressionWindowEntityType.WATCHLATER,
};

export const transformSelectionType = (typename?: string) =>
    typename
        ? selectionTypenameMap[typename] ?? ImpressionWindowEntityType.SELECTION
        : ImpressionWindowEntityType.SELECTION;
